import { CheckedIcon } from 'assets/icons';
import BaseNotification, { BaseNotificationProps } from '../BaseNotification';

interface SuccessNotificationProps extends BaseNotificationProps {
  text: string;
  subText?: string;
}

export default function SuccessNotification({
  text,
  subText,
  ...rest
}: SuccessNotificationProps) {
  return (
    <BaseNotification
      {...rest}
      className="bg-white"
      icon={<CheckedIcon className="w-5 h-5" />}
      header={
        <div className="capitalize text-sm flex items-center text-gray-dark">
          {text}
        </div>
      }
      subHeader={subText}
    />
  );
}
